export default function initCollapsable() {
    document.querySelectorAll('.collapsable').forEach($container => {
        const $toggleCollapse = $container.querySelector('.toggle-collapse');
        const $contentContainer = $container.querySelector('.content-container');

        $toggleCollapse.addEventListener(
            'mousedown',
            function (e) {
                e.preventDefault();
            },
            false
        );
        $toggleCollapse.addEventListener('click', event => {
            if (!event.target.classList.contains('button')) {
                if ($container.classList.contains('is-active')) {
                    $container.classList.remove('is-active');
                    $contentContainer.classList.add('is-hidden');
                } else if (!$container.classList.contains('is-active')) {
                    $container.classList.add('is-active');
                    $contentContainer.classList.remove('is-hidden');
                }
            }
        });
    });
}
